// src/icons/svgs/check.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var SvgCheck = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 28, height: 29, fill: "none", viewBox: "0 0 28 29", ref, ...props, children: /* @__PURE__ */ jsx("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 4, d: "M23.333 7.5 10.5 21.5l-5.833-6.364" }) });
var ForwardRef = forwardRef(SvgCheck);
var check_default = ForwardRef;
export {
  check_default as Check
};
